export function aqmScreenPop(e){return{eScreenPop:e.evt({bind:{type:"RoutingMessage",data:{type:"ScreenPop"}},msg:{}})}}